import { render, staticRenderFns } from "./dashboard.vue?vue&type=template&id=a2d64440&scoped=true"
import script from "./dashboard.vue?vue&type=script&lang=js"
export * from "./dashboard.vue?vue&type=script&lang=js"
import style0 from "./dashboard.vue?vue&type=style&index=0&id=a2d64440&prod&lang=css"
import style1 from "./dashboard.vue?vue&type=style&index=1&id=a2d64440&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d64440",
  null
  
)

export default component.exports